var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('the-breadcrumbs'),_c('page-content',{attrs:{"page-title":"Veranstaltungsort bearbeiten"}},[_c('event-location-form',{attrs:{"loading":_vm.loading,"location":_vm.location,"form-submitted":_vm.saveLocation,"mode":"edit"}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }